

const Home = () => {
  return (

     <>
      Please navigate to a meetingID: 0
     </>
  );
};

export default Home;
